import { render } from "./RatingControl.vue?vue&type=template&id=24304a52&scoped=true"
import script from "./RatingControl.vue?vue&type=script&lang=js"
export * from "./RatingControl.vue?vue&type=script&lang=js"

import "./RatingControl.vue?vue&type=style&index=0&id=24304a52&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24304a52"]])

export default __exports__